import APIService from "./APIService";

export default {
  async getAll() {
    const res = await APIService.apiCall().get("areas/get-areas");
    return res.data;
  },

  async getById(id) {
    const res = await APIService.apiCall().get(`areas/get-by-id/${id}`);
    return res.data;
  },

  async create(data) {
    const res = await APIService.apiCall().post("areas/create", data);
    return res.data;
  },

  async update(id, data) {
    const res = await APIService.apiCall().put(`areas/update/${id}`, data);
    return res.data;
  },

  async delete(id) {
    const res = await APIService.apiCall().delete(`areas/delete/${id}`);
    return res.data;
  },
};
